import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  selectDepositAccountPaymentId,
  selectDepositAccountPaymentStatus,
  selectDepositAccountProvider,
} from '../../../../../selectors/depositAccount';
import { updateDepositAccountPaymentStatus } from '../../../../../actions/depositAccount';
import { checkPaymentStatus } from '../../../../../thunks/payment/checkPaymentStatus';

export const usePaymentStatusContainer = () => {
  const dispatch = useDispatch();

  const status = useSelector(selectDepositAccountPaymentStatus);
  const paymentId = useSelector(selectDepositAccountPaymentId);
  const provider = useSelector(selectDepositAccountProvider);

  const handleRetryClick = useCallback(() => {
    if (paymentId && provider) {
      dispatch(checkPaymentStatus({ setStatusAction: updateDepositAccountPaymentStatus, paymentId, provider }));
    }
  }, [dispatch, paymentId, provider]);

  return { status, handleRetryClick };
};
